import makeRequest from '../makeRequest';
import toHttpHeaders from './toHttpHeaders';
import toHttpRequestBodyMaybe from './toHttpRequestBodyMaybe';
import { HttpMethod, HttpRequest } from '../interfaces';

export type HeaderType = Record<string, string> | Headers | string[][];

const generateRequest = async (
  url: RequestInfo,
  opts?: RequestInit
): Promise<HttpRequest> => {
  const method: HttpMethod = (opts && (opts.method as HttpMethod)) || 'GET';
  const options = {
    body: await toHttpRequestBodyMaybe(opts && opts.body),
    headers: toHttpHeaders(opts && opts.headers),
    creds: opts && opts.credentials
  };
  return makeRequest(method, url.toString(), options);
};
export default generateRequest;
